var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1205_1277)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0804 39.6466C13.0804 35.9248 11.1294 32.7955 8.78823 29.6867L8.07574 28.7541L6.61797 26.8788L5.89143 25.9293L5.17894 24.9673C2.83778 21.7359 0.88681 18.239 0.88681 13.9047C0.88681 6.54892 6.74875 0.562305 14.056 0.361482L14.4352 0.356277L14.8144 0.361482C22.1216 0.562305 27.9836 6.54892 27.9836 13.9047C27.9836 18.239 26.0326 21.7359 23.6915 24.9673L22.979 25.9293L22.2524 26.8788L20.7947 28.7541L20.0822 29.6867C17.8581 32.6401 15.9861 35.612 15.8045 39.0927L15.79 39.6466C15.79 39.6466 15.7401 40.6516 14.4217 40.6516C13.1033 40.6516 13.0804 39.6466 13.0804 39.6466Z",
    fill: "#006BBD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.98646 28.7843L9.98649 28.7843L9.98018 28.7761L9.26769 27.8435L9.26773 27.8434L9.26 27.8335L7.8058 25.9628L7.08982 25.0271L6.38907 24.0809C4.10686 20.9299 2.38681 17.7553 2.38681 13.9047C2.38681 7.36691 7.59443 2.04495 14.0872 1.8612L14.4352 1.85642L14.7832 1.8612C21.276 2.04495 26.4836 7.36691 26.4836 13.9047C26.4836 17.7553 24.7635 20.9299 22.4813 24.0809L21.7806 25.0271L21.0647 25.9626L19.6104 27.8335L19.6104 27.8334L19.6027 27.8435L18.8902 28.7761L18.8902 28.776L18.8839 28.7843C16.8841 31.4399 14.9672 34.3504 14.4352 37.7744C13.903 34.3491 11.9858 31.4393 9.98646 28.7843Z",
    stroke: "#888888",
    strokeWidth: 1,
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1205_1277",
    x: 0.88681,
    y: 0.356277,
    width: 31.0968,
    height: 44.2953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1205_1277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1205_1277",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerSelected);
export default __webpack_public_path__ + "static/media/map-marker-selected.9e70a7c4035bcce528dfd9637627a6cc.svg";
export { ForwardRef as ReactComponent };